import { ERoleIdentifier, EUserPosition, type TUserWithRole } from '../types/user';

// Display order for position pickers; not the same as EUserPosition's declaration order.
export const userPositions: ReadonlyArray<EUserPosition> = [
  EUserPosition.Stammpersonal,
  EUserPosition.Facharzt,
  EUserPosition.Oberarzt,
  EUserPosition.Chefarzt,
];

/** The frontend's `userPositionDefault` (null) as a filter value, which cannot be null. */
export const USER_POSITION_DEFAULT_FILTER = 'AIW';

export const administrativeAccessRoles: ReadonlyArray<ERoleIdentifier> = [
  ERoleIdentifier.ADMINISTRATIVE_STAFF,
  ERoleIdentifier.READ_ONLY,
];

export const appAccessRoles: ReadonlyArray<ERoleIdentifier> = [
  ...administrativeAccessRoles,
  ERoleIdentifier.ROTATING_STAFF,
];

/** A missing user or role never matches. */
export const hasUserRole = (
  user: TUserWithRole | null | undefined,
  roles: ERoleIdentifier | ReadonlyArray<ERoleIdentifier>,
): boolean => {
  const identifier = user?.role?.identifier;
  const allowed: ReadonlyArray<string> = typeof roles === 'string' ? [roles] : roles;
  return !!identifier && allowed.includes(identifier);
};
